/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteRelease} from '../api'

export const useMutationDeleteRelease = createReactQueryMutationHook('deleteRelease', deleteRelease)
